import HeatRecommender from '@components/components/HeatRecommender/HeatRecommender';
import React from 'react';

const CmsHeatRecommender = ({
  visible,
  signUpLink,
  orderLink,
  heatResponses,
}) => (
  <HeatRecommender
    heatResponses={heatResponses}
    isVisible={!!visible}
    orderLink={orderLink}
    signUpLink={signUpLink}
  />
);

export default CmsHeatRecommender;
